'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var LocaleChooser = function LocaleChooser(_a) {
    var children = _a.children,
        _b = _a.availableLocales,
        availableLocales = _b === void 0 ? ['en'] : _b;
    var defaultLocale = availableLocales[0];
    var nav = window.navigator;
    var hasLanguages = nav.languages && nav.languages.length > 0;
    var firstLanguage = hasLanguages && nav.languages[0].split('-')[0];
    var navLang = nav.language && nav.language.split('-')[0];
    var browserLanguage = firstLanguage || navLang || undefined;
    var locale = !browserLanguage || !availableLocales.includes(browserLanguage) ? defaultLocale : browserLanguage;
    return children({ locale: locale });
};
exports.default = LocaleChooser;
//# sourceMappingURL=LocaleChooser.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/web-makeup/dist/LocaleChooser/LocaleChooser.js
// module id = 1238
// module chunks = 0